export const redirectToPurchaseOrderPage = (slug: string) => {
  window.open(`/ground-control/purchase_order_detail/${slug}/`, '_self');
};
